<ngb-toast
  *ngFor="let toast of toasts$ | async"
  [class]="toast.classname + ' shadow-lg rounded'"
  [autohide]="true"
  [delay]="toast.delay"
  (hidden)="remove(toast)">
  <div class="d-flex justify-content-between align-items-center">
    <div>{{ toast.text }}</div>
    <button type="button" class="btn-close btn-close-white ms-2" aria-label="Cerrar"
      (click)="remove(toast)">
    </button>
  </div>
</ngb-toast>
